const ja = {
  nav: { plans: "プラン", howItWorks: "使い方", contact: "お問い合わせ", support: "サポート", consultData: "データ確認", login: "ログイン", portal: "マイページ", crm: "CRM", services: "サービス", chipMobile: "SIMカード", wifiService: "NewSky WiFi" },

  hero: {
    brand: "Mobile",
    overline: "日本での通信は、これひとつで。",
    headline: "インターネットと日本の電話番号を、",
    headlineAccent: "もっと手軽に。",
    sub: "面倒な契約は不要。必要な期間だけ、すぐに使えます。",
    sub2: "物理SIM・eSIM対応。多言語サポートで安心。",
    ctaBuy: "今すぐお申し込み",
    ctaPlans: "料金プランを見る",
  },

  benefits: {
    overline: "メリット",
    title: "必要なものがすべて揃っています",
    items: [
      { title: "日本全国で安定した接続", desc: "日本全地域で高速4G/5Gカバレッジをご提供します。" },
      { title: "とてもお得", desc: "月額¥3,480から、通話付きプランをご用意。" },
      { title: "面倒な手続き不要", desc: "シンプルで迅速な手続き。長期契約は不要です。" },
      { title: "コンビニまたはカードでお支払い", desc: "お好きな方法でお支払い。コンビニ、クレジットカード、銀行振込に対応。" },
      { title: "キャンペーン中の初期費用", desc: "特別割引の初期費用をご利用ください。" },
      { title: "物理SIMまたはeSIMを即日対応", desc: "物理SIMまたはeSIMからお選びください。即時アクティベーション。" },
    ],
  },

  plans: {
    overline: "プラン",
    title: "最適なプランをお選びください",
    sub: "日本の電話番号、データ通信、通話付きプラン。今日から使えます。",
    basic: "ベーシック",
    popular: "人気プラン",
    premium: "プレミアム",
    badge: "一番人気",
    unlimitedCalls: "かけ放題",
    calls60: "60分通話",
    month: "月",
    optional: "オプション",
    unlimitedPlus: "かけ放題",
    activationFee: "初期費用（税込）: ¥3,300",
    cta: "詳しく知りたい",
    features: {
      data: "データ容量",
      callsUnlimited: "かけ放題",
      calls60min: "60分通話付き",
      jpNumber: "日本の電話番号",
      simOrEsim: "物理SIMまたはeSIM",
      supportPt: "ポルトガル語サポート",
      supportPriority: "優先サポート",
    },
  },

  howItWorks: {
    overline: "シンプル＆スピーディー",
    title: "ご利用方法",
    steps: [
      { title: "プランを選ぶ", desc: "データ通信と通話のニーズに合った最適なプランをお選びください。" },
      { title: "SIMまたはeSIMを受け取る", desc: "物理SIMをご自宅で受け取るか、eSIMを即時アクティベーション。" },
      { title: "アクティベーションして利用開始", desc: "SIMを挿入するか、eSIMのQRコードをスキャン。これだけで接続完了！" },
    ],
  },

  trust: {
    overline: "信頼と実績",
    title: "日本で25年以上の接続実績",
    desc: "NewSkyは20年以上にわたり日本で通信サービスを提供し、ポルトガル語、スペイン語、英語での専用サポートを行っています。10万人以上のお客様にご満足いただいています。",
    stats: { years: "日本での実績", customers: "ご利用者数", languages: "対応言語", response: "迅速な対応" },
    langs: ["ポルトガル語", "スペイン語", "英語"],
  },

  contact: {
    overline: "お問い合わせ",
    title: "ご連絡ください",
    form: { name: "お名前", email: "メール", phone: "電話番号", message: "メッセージ", namePh: "お名前を入力", emailPh: "your@email.com", phonePh: "090-XXXX-XXXX", messagePh: "どのようにお手伝いできますか？", submit: "メッセージを送信", sending: "送信中...", success: "送信完了！", error: "エラーが発生しました。" },
    info: { tokyo: "東京", email: "メール", whatsapp: "WhatsApp", whatsappSub: "テキストのみ対応", hours: "営業時間", monFri: "月曜日〜金曜日", sat: "土曜日", hq: "NewSky 本社", hqAddr: "〒163-1030 東京都新宿区西新宿3-7-1 新宿パークタワー N30F", hqNote: "（お客様対応はございません）", office: "NewSky お客様対応窓口", officeAddr: "〒485-0048 愛知県小牧市間々本町123 BBこまきビル 3F" },
  },

  finalCta: {
    overline: "今すぐ始めましょう",
    title: "日本到着時にはもう接続済み",
    desc: "空港を出る前に日本の電話番号とインターネットが使えます。今すぐご相談ください。",
    cta: "今すぐ申し込む",
  },

  supportPage: {
    overline: "ヘルプセンター",
    title: "お困りですか？",
    sub: "よくある質問への回答をご確認いただくか、サポートチームにお問い合わせください。",
    searchPh: "サポートを検索...",
    faqTitle: "よくある質問",
    noResults: "該当する結果がありません：",
    needHelp: "まだお困りですか？",
    whatsapp: "WhatsApp",
    whatsappSub: "迅速な対応",
    phone: "電話",
    emailLabel: "メール",
    backHome: "ホームに戻る",
    faqs: [
      { q: "eSIMのアクティベーション方法は？", a: "ご購入後、メールでQRコードをお送りします。スマートフォンの設定から「モバイル通信」→「プランを追加」でQRコードをスキャンしてください。数分でeSIMが有効になります。" },
      { q: "eSIM対応のスマートフォンは？", a: "iPhone XS以降、Samsung Galaxy S20+以降、Google Pixel 3以降など、最新のスマートフォンの多くが対応しています。お使いの端末の対応状況はWhatsAppでお問い合わせください。" },
      { q: "現在の電話番号を引き継げますか？", a: "はい！MNP（番号ポータビリティ）サービスをご用意しています。現在の番号をNewSky Mobileに移行できます。詳細はお問い合わせください。" },
      { q: "コンビニでの支払い方法は？", a: "メールまたはSMSで支払い票をお送りします。セブンイレブン、ファミリーマート、ローソンなど、どのコンビニでもお支払いいただけます。24時間以内に処理されます。" },
      { q: "ネットワークのカバレッジは？", a: "地方を含む日本全国をカバーしています。日本の大手通信事業者のインフラを使用し、全国で高品質な4G/5G接続を保証します。" },
      { q: "いつでも解約できますか？", a: "はい！当社のプランには契約期間の縛りや解約金はありません。WhatsAppまたは電話でいつでも解約できます。" },
      { q: "物理SIMはどのように届きますか？", a: "日本郵便（JP Post）でお届けします。通常1〜3営業日で届きます。東京のオフィスでの受け取りも可能です。" },
      { q: "契約に必要な書類は？", a: "有効な身分証明書（パスポートまたは在留カード）が必要です。手続きはシンプルで、WhatsAppで完結できます。" },
    ],
  },

  consultar: {
    title: "データ使用量の確認",
    desc: "NewSky MobileのSIMカード情報とデータ使用量を確認するには、SIMカード番号を入力してください",
    label: "SIMカード番号",
    placeholder: "SIM番号を入力",
    button: "確認する",
    consulting: "確認中...",
    result: "確認結果",
    newSearch: "新しい検索",
    simInfo: "SIMカード番号はSIMカードに印字されているか、スマートフォンの設定から確認できます。",
    number: "番号",
    dataUsage: "データ使用量",
    used: "使用済み",
    remaining: "残り",
    plan: "プラン",
    network: "ネットワーク",
    sim: "SIM",
    voice: "音声通話",
    sms: "SMS",
    planStart: "プラン開始日",
    active: "有効",
    suspended: "一時停止中",
    details: "SIM詳細情報",
    serialNumber: "シリアルナンバー",
    activation: "開通日",
    calls: "通話",
    callsUnlimited: "かけ放題（70分/回）",
    planStartDate: "プラン開始日",
    planEndDate: "プラン終了日",
    noExpiry: "期限なし",
    error: "確認中にエラーが発生しました。もう一度お試しください。",
    notFound: "SIMが見つかりません。番号をご確認ください。",
  },

  footer: { back: "戻る" },

  wifi: {
    overline: "WiMAX 5G — 無制限インターネット",
    headline: "高速インターネットを",
    headlineAccent: "どこでも手軽に！",
    sub: "工事不要。技術者不要。設置費用なし。長い待ち時間なし。",
    sub2: "ご家族全員で使える無制限インターネットを数秒で！",
    ctaBuy: "今すぐお申し込み",
    ctaPlans: "料金プランを見る",
    familyText: "ご家族みんなのインターネット！",
    benefitsTitle: "NewSky WiFiが選ばれる理由",
    benefitsOverline: "メリット",
    benefits: [
      { title: "配線不要、工事不要", desc: "届いたら電源を入れて接続するだけ！技術者も壁の穴も待ち時間も不要です。" },
      { title: "無制限インターネット", desc: "動画視聴、仕事、ゲーム、ご家族全員でデータ無制限。" },
      { title: "どこへでも持ち運び", desc: "自宅、職場、旅行先で。長時間バッテリーで一日中使えます。" },
      { title: "高額な費用なし", desc: "法外な設置費用なし。引越し時の追加料金もありません。" },
      { title: "最大16台同時接続", desc: "スマホ、パソコン、タブレット、スマートTV、ゲーム機 — すべて同時に。" },
      { title: "5G WiMAX高速通信", desc: "最先端テクノロジーで最高のパフォーマンスを実現。" },
    ],
    plansOverline: "料金プラン",
    plansTitle: "お支払い方法をお選びください",
    plansSub: "WiMAX 5G 無制限インターネット — 新品端末！",
    konbini: "💴 コンビニ払い",
    card: "💳 クレジットカード自動引落",
    planSky1: "Skyプラン1",
    planSky2: "Skyプラン2",
    tabRent: "レンタル",
    tabBuy: "端末購入",
    month: "/月",
    unlimitedRental: "無制限インターネット＋端末レンタル",
    deviceNew: "🎉 新品端末！",
    activationFee: "初期費用",
    shippingFee: "全国送料",
    totalInitial: "初期費用合計",
    monthlyLabel: "月額：",
    campaign: "特別キャンペーン",
    buyBonus: "🎁 ご購入特典：",
    exempt: "免除",
    free: "無料",
    shippingFree: "全国送料",
    monthlyReduction: "月額料金",
    unlimitedInternet: "無制限インターネット",
    paymentKonbini: "📅 翌月2日〜15日にコンビニでお支払い",
    paymentCard: "💳 翌月にクレジットカードから自動引落",
    noCancel: "✓ 解約金なし",
    minPeriod: "⏱ 最低利用期間：2ヶ月",
    cta: "詳しく知りたい",
    konbiniNote: "ご自宅で配達員にお支払いいただく金額：",
    cardNote: "カードでの安全なお支払い用の請求書をお送りします：",
  },

  portal: {
    loginTitle: "お客様ポータル", loginSub: "サービスとお支払いの管理",
    email: "メールアドレス", emailPh: "your@email.com", password: "パスワード", passwordPh: "パスワードを入力",
    enter: "ログイン", demo: "デモアカウントでログイン",
    forgot: "パスワードを忘れた方", forgotTitle: "パスワードの再設定",
    forgotDesc: "パスワードを再設定するには、サポートまでご連絡ください：",
    forgotClose: "閉じる", backToSite: "サイトに戻る",
    portalLabel: "ポータル",
    nav: { home: "ホーム", services: "サービス", payments: "お支払い", support: "サポート", account: "マイページ", logout: "ログアウト" },
    hello: "こんにちは、", welcome: "NewSky Mobileポータルへようこそ",
    monthlyTotal: "月額合計", pending: "未払い",
    myServices: "ご利用中のサービス", viewAll: "すべて表示", noActiveService: "有効なサービスはありません",
    nextBilling: "次回請求日:", overdueWarning: "注意: {count}件のサービスで支払い遅延が発生しています",
    overdueContact: "サポートまでご連絡ください。", pendingPayments: "未払いのお支払い",
    dueDate: "支払期限:", overdue: "延滞", pendingLabel: "未払い", month: "/月",
    myServicesTitle: "マイサービス", noServiceFound: "サービスが見つかりません",
    since: "開始日", upgrade: "アップグレード", downgrade: "ダウングレード", cancel: "解約",
    requestTitle: "リクエスト", requestDesc: "リクエスト内容を入力してください...", sendRequest: "リクエスト送信", cancelBtn: "キャンセル",
    myRequests: "リクエスト履歴", reqType: "種類", reqDetails: "詳細", reqDate: "日付", reqStatus: "ステータス",
    reqPending: "処理中", reqApproved: "承認済み", reqRejected: "却下",
    statusActive: "有効", statusOverdue: "延滞", statusCancelled: "解約済み",
    paymentsTitle: "お支払い", totalPaid: "支払済み合計", pendingAmount: "未払い", overdueAmount: "延滞",
    openInvoices: "未決済の請求書", invoices: "請求書", payNow: "今すぐ支払う",
    paid: "支払済", open: "未決済", history: "履歴", noPayment: "お支払いはありません",
    amount: "金額", dueDateLabel: "支払期限", paymentDate: "支払日", status: "ステータス",
    supportTitle: "サポート", supportEmpty: "メッセージを送信してサポートを開始してください。",
    supportTeam: "担当者がまもなく対応いたします。", typePlaceholder: "メッセージを入力...",
    accountTitle: "マイページ", personalData: "個人情報", name: "お名前",
    nameChangeNote: "お名前の変更はサポートまでご連絡ください。", phone: "電話番号",
    save: "変更を保存", saved: "情報を更新しました！",
  },
};

export default ja;
